import { TGetCarepointFacilityByNetworkLatAndLongV2ProviderSummary } from 'src/shared/apiResponseTypes'
import {
  IFacility,
  IPractice,
  IPractitioner,
  SearchResults,
} from 'src/shared/types'

export const filterPublishResults = (
  results:
    | SearchResults
    | TGetCarepointFacilityByNetworkLatAndLongV2ProviderSummary[]
    | null
) => {
  if (!results) {
    return []
  }

  return (results as Array<IPractice | IPractitioner | IFacility>).filter(
    item => {
      if (
        (item as IFacility | IPractitioner).publish &&
        (item as IFacility | IPractitioner).publish !== null
      ) {
        const context = (item as IFacility | IPractitioner).publish
          .toString()
          .toLowerCase()
          .trim()

        if (context === 'n' || context === 'no' || context === 'false') {
          return false
        }
      }

      return true
    }
  )
}
